import type { Theme } from '@mui/material';
import { IconButton, styled } from '@mui/material';
import { blueGrey, red } from '@mui/material/colors';
import { PhotoCamera, PlayCircleOutline } from '@mui/icons-material';
import { FiPackage } from 'react-icons/fi';

import type { IThemeDependentStyledComponentProps } from '/common/models';

export const ImageStyled = styled('img')<{ $loading: boolean }>`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.$loading ? 0.5 : 1)};
  will-change: ${(props) => (props.$loading ? 'opacity' : 'auto')};
`;

export const RebuildThumbIconStyled = styled(IconButton)<IThemeDependentStyledComponentProps>`
  position: absolute;
  top: 5px;
  right: 5px;
  color: white;
  background: ${blueGrey[500]};
  padding: 5px;
  z-index: ${({ $theme }: IThemeDependentStyledComponentProps) => ($theme as Theme).zIndex.tooltip};

  &:hover {
    background: ${red[500]};
  }
`;
export const PreviewContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const iconStyles = `
  width: calc(100% - 25%);
  height: calc(100% - 25%);
`;

export const PhotoCameraIcon = styled(PhotoCamera)`
  ${iconStyles}
`;

export const PackageIcon = styled(FiPackage)`
  ${iconStyles}
`;

export const PlayButtonStyled = styled(PlayCircleOutline)(({ theme }) => ({
  position: 'absolute',
  cursor: 'pointer',
  height: '75%',
  width: '75%',
  color: theme.palette.action.selected,
  '&:hover': {
    color: theme.palette.action.active,
  },
}));
